<i18n>
{
  "en": {
    "EnhancedDemoTitle": "BRACK.ch: a virtual tour with enhanced experience"
  },
  "de": {
    "EnhancedDemoTitle": "BRACK.ch: a virtual tour with enhanced experience"
  }
}
</i18n>
<template>
  <embed-viewer-route-view
    :url="'https://tourmake.net/de/tour/a786008b4a652636d1b5fb8081c3b5af'"
    :title="$t('EnhancedDemoTitle')"
    :can-go-back="canGoBack"
  ></embed-viewer-route-view>
</template>
<script>
export default {
  data() {
    return {
      canGoBack: false
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.canGoBack = !!from.name;
    });
  }
};
</script>